/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */
export default {
  apply: 'Apply',
  cancel: 'Cancel',
  closePopup: 'Close Popup',
  fri: 'F',
  inputLabel: 'Date picker Input',
  mon: 'M',
  month1: 'Jan',
  month10: 'Oct',
  month11: 'Nov',
  month12: 'Dec',
  month2: 'Feb',
  month3: 'Mar',
  month4: 'Apr',
  month5: 'May',
  month6: 'June',
  month7: 'July',
  month8: 'Aug',
  month9: 'Sept',
  nextMonth: 'Next Month',
  prevMonth: 'Previous Month',
  sat: 'S',
  sun: 'S',
  thu: 'T',
  toggleDropdown: 'Toggle Dropdown',
  tue: 'T',
  wed: 'W',
  weekHeader: 'W'
};
